import React from "react";
import { Box, LinearProgress } from "@mui/material";

interface ProgressOverlayProps {
  active: boolean;
}

const ProgressOverlay: React.FC<ProgressOverlayProps> = ({ active }) => {
  if (!active) return null;

  return (
    <Box
      position="absolute"
      inset={0}
      display="flex"
      alignItems="center"
      justifyContent="center"
      bgcolor="rgba(255,255,255,0.6)"
      zIndex={999}
    >
      <LinearProgress sx={{ width: "40%" }} />
    </Box>
  );
};

export default ProgressOverlay;